export const iconFontAwesomeSecurityDoorClosed = (
	<i className="fa-solid fa-door-closed"></i>
);
